import { createContext, ReactNode, useContext, useState } from "react"

export type Themes = 'dark' | 'light';

export interface IGlobalContext 
{
    GetTheme?: () => Themes;
    ToogleTheme?: () => void;    
    AfterThemeChangeEvent: (()=> void)[]
}

export interface IGlobalContextProps
{
    Context?: IGlobalContext,
    SetContext?: (context: IGlobalContext) => void 
}


const contextType = createContext<IGlobalContextProps>({});

export default function GlobalContext({children} : {children : ReactNode})
{
    let [data, setData] = useState<IGlobalContext>({AfterThemeChangeEvent: []});

    return(
        <contextType.Provider value={{Context: data, SetContext: setData}}>
            {children}
        </contextType.Provider>
    )
}


export function useGlobalContext()
{
    return useContext(contextType);
}